// @version V0.0.1 [Tuesday - 20201103_092924] : init

const getDefaultState = () => {
    return {
        someInitialState: true,
        option_roles: [],
        page_roles: [],
        action_roles: []
    }
}
import { updateField, getField } from "vuex-map-fields";
import { REQUEST_FAILED, REQUEST_SENDED, REQUEST_SENDING, RESET_STATE } from "../constant-types";

import {
    sendRequest
} from "./../api";

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        setOptionRoles(state, payload) {
            state.option_roles = payload
        },
        setPageRole(state, payload) {
            state.page_roles = payload;
        },
        setActionRole(state, payload) {
            state.action_roles = payload;
        },
        addOptionRole(state) {
            state.option_roles.push({
                id: null,
                name: '',
                description:''
            })
        },
        removeOptionRole(state, idx) {
            state.option_roles.splice(idx, 1)
        },
        updateField
    },
    // can async
    actions: {
        loadOptionRoles({commit}) {
            //job title
            return axios.get('role/option')
                .then((response) => {
                    //success
                    commit('setOptionRoles', response.data);
                });
        },
        getPageRole({commit}) {
            return sendRequest('role/page-role', {}, 'get', (response) => commit('setPageRole', response), () => {}, () => {})
        },
        getActionRole({commit}) {
            return sendRequest('role/action-role', {}, 'get', (response) => commit('setActionRole', response), () => {}, () => {})
        },
        requestUpdateOptionRole({commit, state, dispatch}) {
            commit('requestStatus/'+ [REQUEST_SENDING], null, {
                root: true
            });
            return sendRequest('role/option-role', { option_roles : state.option_roles }, 'put',
                (successResponse) => {
                    commit('requestStatus/'+ [REQUEST_SENDED], null, {
                        root: true
                    })
                    // update id if have new
                    commit('setOptionRoles', successResponse)
                },
                () => {
                    commit('requestStatus/'+ [REQUEST_FAILED], null, {
                        root: true
                    })
                    // should reload page role, to refresh deleted role
                    dispatch('loadOptionRoles')
                },
                () => {
                    commit('requestStatus/'+ [REQUEST_SENDED], null, {
                        root: true
                    })
                },
                true,
                true, 
                true
             )
        },
        requestSaveActionRole({commit, state}) {
            commit('requestStatus/'+ [REQUEST_SENDING], null, {
                root: true
            });
            let action_roles = state.action_roles.map(ar => ({
                id: ar.id,
                key: ar.key,
                roles: ar.roles.map( arr => ({ id: arr.id }) )
            }))
            return sendRequest('role/action-role', { action_roles }, 'put',
                (successResponse) => {
                    commit('requestStatus/'+ [REQUEST_SENDED], null, {
                        root: true
                    })
                },
                () => {
                    commit('requestStatus/'+ [REQUEST_FAILED], null, {
                        root: true
                    })
                },
                () => {
                    commit('requestStatus/'+ [REQUEST_SENDED], null, {
                        root: true
                    })
                },
                true,
                true, 
                true
             )
        },
        requestSavePageRole({commit, state}) {
            commit('requestStatus/'+ [REQUEST_SENDING], null, {
                root: true
            });
            // for optimize
            let page_roles = state.page_roles.map(pr => ({
                id: pr.id,
                key: pr.key,
                roles: pr.roles.map( prr => ({ id: prr.id }) )
            }))
            return sendRequest('role/page-role', { page_roles }, 'put',
                (successResponse) => {
                    commit('requestStatus/'+ [REQUEST_SENDED], null, {
                        root: true
                    })
                },
                () => {
                    commit('requestStatus/'+ [REQUEST_FAILED], null, {
                        root: true
                    })
                },
                () => {
                    commit('requestStatus/'+ [REQUEST_SENDED], null, {
                        root: true
                    })
                },
                true,
                true, 
                true
             )
        }
    },
    // call variable with custom display
    getters: {
        getField
    }
})
